<h2 mat-dialog-title>Report chat trace</h2>

<mat-dialog-content class="report">
  <div class="report__rows">
    <div class="report__row">
      <span class="report__label">Date</span>
      <span class="report__value">{{ report().generated_at }}</span>
    </div>
    <div class="report__row">
      <span class="report__label">User</span>
      <span class="report__value">{{ report().user ?? "—" }}</span>
    </div>
    <div class="report__row">
      <span class="report__label">Agent</span>
      <span class="report__value">{{ report().agent_id ?? "—" }}</span>
    </div>
    <div class="report__row">
      <span class="report__label">Thread ID</span>
      <span class="report__value report__value--mono">{{ report().thread_id ?? "—" }}</span>
      <button mat-icon-button class="report__copy" aria-label="Copy thread id" (click)="copyValue(report().thread_id)">
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>
    <div class="report__row">
      <span class="report__label">Current run ID</span>
      <span class="report__value report__value--mono">{{ report().current_run_id ?? "—" }}</span>
      <button mat-icon-button class="report__copy" aria-label="Copy current run id" (click)="copyValue(report().current_run_id)">
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>
  </div>

  <div class="report__section">
    <p class="report__label">Runs ({{ report().runs.length }})</p>
    @for (run of report().runs; track run.run_id) {
    <div class="report__run">
      <span class="report__value--mono">{{ run.run_id }}</span>
      <span class="report__status" [attr.data-status]="run.status">{{ run.status }}</span>
      <span class="report__time">{{ run.started_at }}</span>
    </div>
    } @empty {
    <p class="report__empty">No runs captured in this session yet.</p>
    }
  </div>

  <div class="report__section">
    <p class="report__label">Initial input</p>
    <p class="report__text">{{ report().initial_input ?? "—" }}</p>
  </div>

  <div class="report__section">
    <p class="report__label">Conversation ({{ report().conversation.length }} messages)</p>
    <div class="report__conversation">
      @for (message of report().conversation; track $index) {
      <p class="report__bubble" [attr.data-role]="message.role">
        <strong>{{ message.role }}</strong>
        · {{ message.content }}
      </p>
      } @empty {
      <p class="report__empty">No conversation text yet.</p>
      }
    </div>
  </div>

  <label class="report__label report__feedback-label" for="report-feedback">Your feedback</label>
  <textarea
    id="report-feedback"
    class="report__feedback"
    rows="4"
    [value]="feedback()"
    (input)="onFeedbackInput($event)"
    placeholder="Describe what went wrong or what you expected…"></textarea>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button (click)="downloadReport()">
    <mat-icon>download</mat-icon>
    Download JSON
  </button>
  <button mat-flat-button color="primary" (click)="copyReport()">
    <mat-icon>content_copy</mat-icon>
    {{ copied() ? "Copied!" : "Copy JSON" }}
  </button>
</mat-dialog-actions>
